import styles from './checkout.module.css';
import { CheckoutProduct } from './checkout-product';
import { Modal } from './modal';
import { CheckoutAddress } from './checkout-address';
import { TotalPrice } from '../cart/total-price';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/hooks';

export const Checkout = ({ extraClass }: { extraClass: string }) => {
  const { t } = useTranslation('checkout', { useSuspense: false })
  const { items } = useAppSelector(state => state.cart);
  const { order } = useAppSelector(state => state.checkout);

  return (
    <section className={`${styles.container} ${extraClass}`}>
      <h2>{t('orderConfirmation')}</h2>
      <h3 className={styles.title}>{t('items')}</h3>
      {items.map((item, index) => {
        return <CheckoutProduct key={index} {...item} />;
      })}
      <CheckoutAddress extraClass={styles.address} />
      {!!order && !!order.id && <Modal number={order.id} />}
      <TotalPrice />
    </section>
  );
};
